import { useState } from "react";
import { BG, CARD, CARD2, CARD3, BD, TX, TX2, BL, GR, YL } from "../../utils/constants";

export default function TrialEndedGate({ onSubscribe, onLogout }) {
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      await onSubscribe();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ts-scan-shell" style={{ minHeight: "100vh", background: BG, color: TX, fontFamily: "'IBM Plex Mono',monospace", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600;700&family=Space+Grotesk:wght@800&display=swap');`}</style>
      <div className="ts-panel" style={{ background: CARD, border: `1px solid ${BD}`, borderRadius: 14, padding: 28, maxWidth: 420, width: "100%", boxShadow: "0 28px 80px rgba(0,0,0,0.45)", textAlign: "center" }}>
        <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 52, height: 52, borderRadius: "50%", background: `${YL}14`, border: `1px solid ${YL}40`, marginBottom: 16 }}>
          <span style={{ fontSize: 22 }}>⏳</span>
        </div>

        <div className="ts-gradient-text" style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 900, fontSize: 22, marginBottom: 8 }}>
          Your trial has ended
        </div>
        <div style={{ color: TX2, fontSize: 11, lineHeight: 1.8, marginBottom: 22 }}>
          Your free trial period is over. Subscribe to keep scanning the market, tracking your watchlist, and getting price alerts.
        </div>

        <div style={{ background: CARD2, border: `1px solid ${GR}30`, borderRadius: 10, padding: "16px", marginBottom: 18 }}>
          <div style={{ fontSize: 26, fontWeight: 900, color: GR, fontFamily: "'Space Grotesk',sans-serif" }}>$3<span style={{ fontSize: 12, color: TX2, fontWeight: 400 }}> / month</span></div>
          <div style={{ fontSize: 9, color: TX2, marginTop: 4 }}>Cancel anytime. Billed monthly.</div>
        </div>

        <button
          onClick={submit}
          disabled={loading}
          style={{ width: "100%", background: loading ? CARD3 : `linear-gradient(135deg,${GR},${BL})`, border: "none", borderRadius: 10, padding: "13px 0", color: loading ? TX2 : "#000", fontSize: 11, fontWeight: 800, cursor: loading ? "not-allowed" : "pointer", letterSpacing: 2, marginBottom: 10 }}
        >
          {loading ? "…" : "PRESS HERE TO PAY $3 →"}
        </button>
        <button className="btn" onClick={onLogout} style={{ width: "100%", background: "transparent", border: `1px solid ${BD}`, borderRadius: 9, padding: 10, color: TX2, fontSize: 9 }}>Sign out</button>
      </div>
    </div>
  );
}
